import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { AxnCompany } from "@idw-types/data/reference-data/axn";

type GetAxnCompaniesRequestResponse = {
    axnCompanies: Array<AxnCompany>;
};

export const getAxnCompaniesRequest = async (): Promise<{ data: GetAxnCompaniesRequestResponse, error: any }> => {
    const route = apiRoutes.axnadminCore.data.axncompany;
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};